import React from 'react';
import PropTypes from 'prop-types';
export default function IcEye({ classname }){
  return(
    <svg className={classname} fill="none" height="12" viewBox="0 0 20 12" width="20" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.0004 4.00462C12.2095 4.00462 14.0004 5.79549 14.0004 8.00462C14.0004 10.2138 12.2095 12.0046 10.0004 12.0046C7.79122 12.0046 6.00036 10.2138 6.00036 8.00462C6.00036 5.79549 7.79122 4.00462 10.0004 4.00462ZM10.0004 5.50462C8.61965 5.50462 7.50036 6.62391 7.50036 8.00462C7.50036 9.38534 8.61965 10.5046 10.0004 10.5046C11.3811 10.5046 12.5004 9.38534 12.5004 8.00462C12.5004 6.62391 11.3811 5.50462 10.0004 5.50462ZM10.0004 0.5C14.6139 0.5 18.5965 3.65001 19.7015 8.06439C19.8021 8.4662 19.5579 8.87348 19.1561 8.97406C18.7542 9.07465 18.347 8.83045 18.2464 8.42863C17.3075 4.67796 13.9217 2 10.0004 2C6.07729 2 2.69046 4.68026 1.75322 8.43315C1.65286 8.83502 1.24572 9.07944 0.843845 8.97908C0.441975 8.87872 0.197554 8.47158 0.297916 8.06971C1.40101 3.65272 5.38484 0.5 10.0004 0.5Z" fill="currentColor"/>
    </svg>

  );
}

IcEye.propTypes = {
  classname: PropTypes.string,
};

